import { render, staticRenderFns } from "./showOrderByGoods.vue?vue&type=template&id=4130ff94&scoped=true"
import script from "./showOrderByGoods.vue?vue&type=script&lang=js"
export * from "./showOrderByGoods.vue?vue&type=script&lang=js"
import style0 from "./showOrderByGoods.vue?vue&type=style&index=0&id=4130ff94&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4130ff94",
  null
  
)

export default component.exports